const STATUSES = {
  draft: 'draft',
  active: 'active',
  inactive: 'inactive',
  archived: 'archived',
}

export default function Status({ status = '' }) {
  if (!status) return null

  return (
    <div className={`details-item__message ${STATUSES[status]}`}>
      <i className={`hb-ico practice-${STATUSES[status]}-ico`} />
      {status}
    </div>
  )
}
